import { render, staticRenderFns } from "./CasesSection.vue?vue&type=template&id=0b82c678&scoped=true"
import script from "./CasesSection.vue?vue&type=script&lang=js"
export * from "./CasesSection.vue?vue&type=script&lang=js"
import style0 from "./CasesSection.vue?vue&type=style&index=0&id=0b82c678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b82c678",
  null
  
)

export default component.exports